// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/EmailNotification/index.css
// module id = 3118
// module chunks = 0